{
  "version": 1,
  "asset_id": "cf3c2cf0-aee7-400d-a995-7b69adb93f71",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/cf3c2cf0-aee7-400d-a995-7b69adb93f71/the-inner-flame-sutra-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/cf3c2cf0-aee7-400d-a995-7b69adb93f71/the-inner-flame-sutra-cover.png",
  "original_filename": "the-inner-flame-sutra-cover.png",
  "size": 2796183,
  "content_type": "image/png",
  "created_at": "2026-07-15T00:31:25Z"
}
